import { Config } from '@ratehub/base-ui';

import getSharedDepositShape from './getSharedDepositShape';
import fetchDeposit from './fetchDeposit';


const API_ENDPOINT = `${Config.CHEQUING_API_URL}/account-queue`;

/**
 * Fetch chequing products according to options
 * @param {object} options - Options for fetching chequing products
 * @param {string} options.province - Province code
 * @param {string} options.language - Language code
 * @param {object[]} options.products - An array of requested products ordered by priority
 * @returns {Promise<object>} A promise that resolves to an object containing the fetched products
 */
async function fetchChequing(options) {
    const response = await fetchDeposit(options, API_ENDPOINT);

    return {
        data: {
            products: response.data?.products?.map(getProductShape) || [],
        },
    };
}

function getProductShape(product) {
    return product
        ? getSharedDepositShape(product)
        : undefined;
}

export default fetchChequing;
